/* eslint-disable @nx/enforce-module-boundaries */
'use client';
import { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Flex, Spacer, VStack } from '@mybridge/ui/layout';
import { StackDivider } from '@chakra-ui/react';
import { Heading, Link, Text } from '@mybridge/ui';
import {
  Stat,
  StatArrow,
  StatHelpText,
  StatLabel,
  StatNumber,
} from '@mybridge/ui/stat';
import _ from 'lodash';
import { MyProfileContext } from 'v4/components/profile/context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
export const MyProfileAnalytics = (props) => {
  const { analyticsList, iscompanypage, companyId } = props;
  const [showModalType, setShowModalType] = useState('');
  const onClose = () => setShowModalType('');
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const { myAnalytics } = useContext(MyProfileContext);
  const analytics = _.cloneDeep(myAnalytics);
  const { formatNumber } = useNumberFormatter();
  const links = {
    'Search Apperances': '/profile/network/viewers',
    'Profile Views': '/profile/network/viewers',
    'New Connections': '/profile/network/my-circle',
  };
  return (
    <>
      <Heading fontSize="18px" color="#3D5A80" fontWeight="400">
        {t('profile.analytics') || "Analytics"}
      </Heading>
      <VStack
        divider={<StackDivider borderColor="gray.200" />}
        spacing={1}
        align="stretch"
      >
        {analytics
          ?.sort?.((a, b) => a?.order - b?.order)
          ?.map?.((ma, maIndex) => (
            ma?.total_count && <Stat key={maIndex}>
              <Flex minWidth="max-content" alignItems="center" gap="2">
                <Box py="2">
                  <StatNumber
                    color="#5B5B5B"
                    fontWeight={500}
                    fontSize="15px"
                  >
                    {formatNumber(ma?.total_count) || 0}
                  </StatNumber>
                  {ma?.title?.length ? (
                    <StatLabel
                      as={Link}
                      href={links?.[ma?.title]}
                      fontWeight={400}
                      fontSize="15px"
                      color="#5B5B5B"
                    >
                      {ma?.title}
                    </StatLabel>
                  ) : (
                    ''
                  )}
                  {ma?.sub_title?.length ? (
                    <StatLabel as={Text} fontWeight={400} color="#5B5B5B" fontSize="13px">
                      {ma?.sub_title}
                    </StatLabel>
                  ) : (
                    ''
                  )}
                </Box>
                <Spacer />
                <Box py="2">
                  <StatHelpText>
                    {(ma?.data?.val) || 0}
                    <StatArrow
                      type={
                        ma?.data?.performance === 'INC'
                          ? 'increase'
                          : 'decrease'
                      }
                      style={{ marginLeft: '0.8rem' }}
                      color={ma?.data?.color_code}
                    />
                  </StatHelpText>
                </Box>
              </Flex>
            </Stat>
          ))}
      </VStack>
    </>
  );
};
